import { useQuery } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

// Single prophet page by prophet.pages._id — the settings route only needs
// appPage._id, so this replaces fetching the whole department listing there.
export const getProphetPage: prophetTypes.GetProphetPage = (pageId) => {
  return axios.get(`/prophet/pages/${pageId}`);
};

type QueryFnType = typeof getProphetPage;

type UseGetProphetPageOptions = {
  pageId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetProphetPage = ({ config = {}, pageId }: UseGetProphetPageOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['prophet-page', pageId],
    enabled: !!pageId,
    queryFn: () => getProphetPage(pageId),
  });
};
